import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ApiService } from '@services';

/**
 * Logs service.
 *
 * @author Ihar Kazlouski
 * @class LogsServiceClass
 * @category Services
 */
var LogsServiceClass = /*#__PURE__*/function () {
  function LogsServiceClass() {
    _classCallCheck(this, LogsServiceClass);
  }

  _createClass(LogsServiceClass, [{
    key: "apiLogsGet",
    value:
    /**
     * Logs get api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<LogsResponseType>>} logs.
     */
    function () {
      var _apiLogsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", ApiService.apiGet('/logs/super-admins', _objectSpread({
                  prefixURL: '/log-info'
                }, params)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function apiLogsGet(_x) {
        return _apiLogsGet.apply(this, arguments);
      }

      return apiLogsGet;
    }()
    /**
     * Logs filter post api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<AdminUsersResponseType>>} filtered logs list promise.
     */

  }, {
    key: "apiSearchLogsPost",
    value: function () {
      var _apiSearchLogsPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", ApiService.apiPost('/search-logs/super-admins', _objectSpread({}, params === null || params === void 0 ? void 0 : params.body), _objectSpread({
                  prefixURL: '/log-info'
                }, params)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function apiSearchLogsPost(_x2) {
        return _apiSearchLogsPost.apply(this, arguments);
      }

      return apiSearchLogsPost;
    }()
    /**
     * Admin groups users get api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<GroupsUsersResponseType[]>>} admin groups users.
     */

  }, {
    key: "apiAdminUsersNamesGet",
    value: function () {
      var _apiAdminUsersNamesGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", ApiService.apiGet('/super-admins/names', _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function apiAdminUsersNamesGet(_x3) {
        return _apiAdminUsersNamesGet.apply(this, arguments);
      }

      return apiAdminUsersNamesGet;
    }()
  }]);

  return LogsServiceClass;
}();

var LogsService = new LogsServiceClass();
export { LogsService };